<template>
  <main-layout>
    <section class="article_index" @click="showArticleSort=false">
      <div class="wrap">
        <div class="a_header">
          <h4>{{$t('global.文章')}}</h4>
          <router-link to="/article/edit">{{$t('global.写文章')}}</router-link>
        </div>
        <div class="container">
          <div @click.stop.prevent="showArticleSortList" class="sort">
            <span>
              <img :src="sortArticleSelected.icon" />
              {{sortArticleSelected.title}}
            </span>
            <ul @click.stop="sortArticle" v-if="showArticleSort">
              <li v-for="item in sortList" :key="item.id" :data-sort="item.id">
                <img :src="item.icon" />
                {{item.title}}
              </li>
            </ul>
          </div>
          <ul class="list">
            <li v-for="item in acticleList" :key="item.id">
              <article-card :item="item" />
            </li>
          </ul>
        </div>
        <pagination
          :totalRecord="totalRecord"
          :pageSize="pageSize"
          :pageIndex="pageIndex"
          @OnCurrentChanged="changePage"
        />
      </div>
    </section>
  </main-layout>
</template>


<script>
import MainLayout from "@/layouts/MainLayout";
import Header from "@/components/v2/Header";
import Footer from "@/components/v2/Footer";
import ArticleCard from "@/components/v2/article/ArticleCard";
import Pagination from "@/components/v2/Pagination";
export default {
  metaInfo() {
    return {
      title: this.$t("global.文章列表") + " | MANA"
    };
  },
  components: {
    ArticleCard,
    "mana-header": Header,
    "mana-footer": Footer,
    MainLayout,
    Pagination
  },
  data() {
    return {
      showArticleSort: false,
      sortArticleSelected: {
        id: 0,
        icon: "/static/v2/match/sort_latest.png",
        title: this.$t("global.最新排序")
      },
      sortList: [
        {
          id: 0,
          icon: "/static/v2/match/sort_latest.png",
          title: this.$t("global.最新排序")
        },
        {
          id: 1,
          icon: "/static/v2/match/sort_hot.png",
          title: this.$t("global.热门排序")
        }
      ],
      acticleList: [],
      pageSize: 20,
      pageIndex: 1,
      totalRecord: 0
    };
  },
  mounted() {
    this.getArticleList();
    this.buriedPoint(41,0)
  },
  methods: {
    showArticleSortList() {
      this.showArticleSort = true;
    },
    sortArticle() {
      this.sortArticleSelected = this.sortList[
        event.target.getAttribute("data-sort")
      ];
      this.pageIndex = 1;
      this.showArticleSort = false;
      this.getArticleList();
    },
    getArticleList() {
      const url = "/api/article/findArticlePage";
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        orderBy: this.sortArticleSelected.id
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.acticleList = res.data.list;
          this.totalRecord = res.data.totalRecord;
        }
      });
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getArticleList();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style lang="stylus" scoped>
.article_index {
  background: #fff;
  min-height: calc(100vh - 228px);

  .wrap {
    width: 920px;
    margin: 0 auto;
    padding-top: 70px;

    .a_header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      h4 {
        font-size: 44px;
      }

      a {
        background: #2026CC;
        color: #fff;
        font-size: 16px;
        padding: 10px 40px;

        &:hover {
          background: #1C21B0;
        }

        &::before {
          content: '';
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url('/static/v2/article/article_write_icon.png') no-repeat;
          background-size: 20px;
          vertical-align: bottom;
          margin-right: 8px;
        }
      }
    }

    .container {
      width: 920px;
      padding-top: 24px;

      .sort {
        line-height: 33px;
        text-align: right;
        position: relative;
        font-size: 14px;
        font-weight: 400;

        span {
          cursor: pointer;
          display: inline-block;
          color: #0A0A0A;
          font-size: 14px;
          cursor: pointer;
          line-height: 16px;

          img {
            width: 18px;
            height: 18px;
            vertical-align: sub;
            margin-top: 4px;
          }
        }

        ul {
          width: 125px;
          box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
          border: 1px solid rgba(235, 235, 235, 1);
          position: absolute;
          top: 33px;
          right: -26px;
          z-index: 1;
          background: #fff;
          padding: 10px 0;

          li {
            line-height: 34px;
            cursor: pointer;
            text-align: center;

            &:hover {
              background: #F5F5F5;
            }

            img {
              width: 18px;
              height: 18px;
              vertical-align: sub;
            }
          }
        }
      }

      .list {
        margin-top: -16px;

        li {
          padding: 30px 0 25px;
          border-bottom: 1px solid #EBEBEB;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/article/ArticleIndex.vue